// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-console */
import { isEnvProduction } from './isProduction';

export interface AnalyticEvent {
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  eventValue?: string | number | boolean;
}

const DEFAULT_EVENT_CATEGORY = 'Партнерский кабинет';

export enum EventType {
  mainEvent = 'mainEvent',
}

export const sendAnalytics = (event: AnalyticEvent) => {
  const fullEvent = { event: EventType.mainEvent, eventCategory: DEFAULT_EVENT_CATEGORY, ...event };

  if (!isEnvProduction()) {
    console.groupCollapsed(`Analytics Event: ${(fullEvent as AnalyticEvent).eventAction}`);
    console.table(
      Object.entries(fullEvent)
        .filter(([_, value]) => value)
        .map(([key, value]) => ({ key, value })),
    );
    console.groupEnd();

    return;
  }

  if (typeof window !== 'undefined') {
    window.sravniDataLayer = window.sravniDataLayer || [];
    window.sravniDataLayer.push(fullEvent);
  }
};

declare global {
  interface Window {
    sravniDataLayer: any[];
  }
}
